import { styled } from 'styled-components';

export const ActionsButtonsWrap = styled.div`
  width: 20rem;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .delete-strategy-button {
    color: ${props => props.theme.colors.veryDarkGrey};
  }

  .strategy-button {
    &:not(:last-child) {
      margin-right: 0.5rem;
    }
  }
`;

export const ActionMessage = styled.p`
  margin: 0 0.3rem 0 0;
`;
